import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Coupon } from '../coupon.model';

@Component({
  selector: 'app-coupon-stats',
  templateUrl: './coupon-stats.component.html',
  styleUrls: ['./coupon-stats.component.css']
})
export class CouponStatsComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Coupon,
    private dialogRef: MatDialogRef<CouponStatsComponent>
  ) {}

  get isStoredValueCoupon(): boolean {
    return this.data.discountType === 'fixed';
  }

  get validFromDisplay(): string {
    if (!this.data.validFrom) return '—';
    const d = this.data.validFrom?.toDate ? this.data.validFrom.toDate() : new Date(this.data.validFrom);
    return d.toLocaleDateString('nb-NO');
  }

  get validUntilDisplay(): string {
    if (!this.data.validUntil) return '—';
    const d = this.data.validUntil?.toDate ? this.data.validUntil.toDate() : new Date(this.data.validUntil);
    return d.toLocaleDateString('nb-NO');
  }

  get createdAtDisplay(): string {
    if (!this.data.createdAt) return '—';
    const d = this.data.createdAt?.toDate ? this.data.createdAt.toDate() : new Date(this.data.createdAt);
    return d.toLocaleDateString('nb-NO');
  }

  get createdByDisplay(): string {
    return this.data.createdBy || '—';
  }

  get recentUsedBy(): string[] {
    if (!this.data.usedBy || this.data.usedBy.length === 0) return [];
    return this.data.usedBy.slice(-10).reverse();
  }

  get remainingBalanceDisplay(): string {
    if (!this.isStoredValueCoupon) return '—';
    return `NOK ${this.data.remainingBalance ?? this.data.discountValue}`;
  }

  get spentAmountDisplay(): string {
    if (!this.isStoredValueCoupon) return '—';
    const remainingBalance = this.data.remainingBalance ?? this.data.discountValue;
    return `NOK ${Math.max(this.data.discountValue - remainingBalance, 0)}`;
  }

  close() {
    this.dialogRef.close();
  }
}
